// Generated by CoffeeScript 2.7.0
export var EditingListItemMixin = {
  props: {
    editingVm: {
      type: Vue
    }
  },
  computed: {
    editing: function() {
      return this === this.editingVm;
    }
  },
  methods: {
    editingVmChangedFunc: function(vm) {
      return this.$emit('editingVmChanged', vm);
    },
    addNewItemFunc: function() {
      return this.$emit('addNewItem');
    }
  }
};

export var EditingListItem = Vue.extend({
  props: {
    item: {
      type: Skylark.App.BaseModel,
      required: true
    },
    itemClass: {
      type: [Array, String]
    },
    editingPropName: {
      type: String,
      default: 'name'
    },
    inputPlaceholder: {
      type: String,
      default: '请输入'
    }
  },
  mixins: [EditingListItemMixin],
  template: `<div class='editing-list-item list-item' :class='itemClass' @click.stop='itemClickedFunc'>
  <div class='tip icon'>
    <slot name='tip-template' :item='item' :editing='editing'></slot>
  </div>
  <div class='content'>
    <div v-show='!editing'>{{ item[editingPropName]}}</div>
    <div class="justify-box" v-show="editing">
      <input ref='inputRef'
             :value='item[editingPropName]'
             @keyup.enter='inputUpdateAndAddNewItemFunc'
             type='text'
             placeholder='请输入分组名称' />
      <div class="btn icon-btn floated ml-3" @click.stop="inputUpdateFunc">
        <i class="slp-check" ></i>
      </div>
      <div class="btn icon-btn floated ml-3" @click.stop="cancelInputFunc">
        <i class="slp-times" ></i>
      </div>
    </div>
  </div>
  <div class='tip editing-list-item-actions'>
    <slot name='additional-actions' :item='item'></slot>
    <div class='btn icon-btn btn-small' @click.stop='edit'><i class='slp-pencil'></i></div>
    <div class='btn icon-btn btn-small' @click.stop='destroy'><i class='slp-trash'></i></div>
  </div>
</div>`,
  created: function() {
    if (this.item.isNew()) {
      return this.edit();
    }
  },
  watch: {
    editing: function(val, oldVal) {
      if (val) {
        return this.edit();
      } else {
        return this.update();
      }
    }
  },
  methods: {
    getInputValue: function() {
      return this.$refs.inputRef.value.trim();
    },
    edit: function() {
      if (!this.editing) {
        this.$emit('editingVmChanged', this);
      }
      return this.$nextTick(function() {
        return this.$refs.inputRef.focus();
      });
    },
    inputUpdateFunc: function() {
      this.update();
      return this.$emit('editingVmChanged', null);
    },
    cancelInputFunc: function() {
      var value;
      value = this.item[this.editingPropName];
      if (_.isEmpty(value)) {
        this.destroy();
      } else {
        this.$refs.inputRef.value = value;
      }
      return this.$emit('editingVmChanged', null);
    },
    inputUpdateAndAddNewItemFunc: function() {
      this.inputUpdateFunc();
      return this.$emit('addNewItem');
    },
    itemClickedFunc: function() {
      return this.$emit('itemClicked');
    },
    update: function() {
      var value;
      value = this.getInputValue();
      if (_.isEmpty(value)) {
        return this.destroy();
      } else {
        return this.$emit('inputChanged', value);
      }
    },
    destroy: function() {
      if (this.item.isNew()) {
        return this.item.destroy();
      } else {
        return this.$emit('destroyed');
      }
    }
  }
});

export default EditingListItem;
